module.exports = __webpack_public_path__ + "assets/img/youer-a4d1c207.png";